var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section_politica containerg"},[_c('div',{staticClass:"title_politica"},[_vm._v(_vm._s(_vm.$t('faq_support')))]),_c('div',{staticClass:"container_politica"},[_vm._v("\n            Urmeaza    \n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }